import { Formik } from 'formik'
import React from 'react'
import {
  staffingAgencyPocsDocument,
  useStaffingAgencyPocById,
  UseMutateStaffingAgencyPocByIdReturn,
  useMutateStaffingAgencyPocById,
  staffingAgencyPocByIdDocument
} from 'src/queries'
import Form from './Form'
import validationSchema from '../helpers/formValidation'
import { useInvalidateQueryByDocument } from 'src/hooks/useGraphQL'
import { pick } from 'lodash'
import { emptyStringToNull } from 'src/helpers/formHelpers'
import useLookups from '../helpers/useLookups'

interface FormContextProps {
  toggle: () => void
  staffingAgency: string
  id: string
}

export type Values = Parameters<UseMutateStaffingAgencyPocByIdReturn['mutate']>[0]['record']

const FormContext: React.FC<FormContextProps> = (props) => {
  const { toggle, staffingAgency, id } = props
  const update = useMutateStaffingAgencyPocById()
  const poc = useStaffingAgencyPocById(id)
  const lookups = useLookups()
  const invalidatePOCs = useInvalidateQueryByDocument(staffingAgencyPocsDocument)
  const invalidatePOC = useInvalidateQueryByDocument(staffingAgencyPocByIdDocument)
  const handleSuccess = (): void => {
    void invalidatePOCs({ filter: { staffingAgency } })
    void invalidatePOC({ id })
    toggle()
  }
  const initialState: Values = pick(poc, [
    'name',
    'title',
    'email',
    'phone',
    'address',
    'timezone',
    'type'
  ])
  return (
    <Formik
      initialValues={initialState}
      validationSchema={validationSchema}
      onSubmit={async (data) => {
        const record = {
          ...data,
          staffingAgency
        }
        emptyStringToNull(record, 'type')
        emptyStringToNull(record, 'timezone')

        update.mutate({ id, record }, { onSuccess: handleSuccess })
      }}
    >
      {(props) => (
        <Form toggle={toggle} isLoading={update.isLoading} hasError={update.isError} lookups={lookups} />
      )}
    </Formik>
  )
}

export default FormContext
